export default __webpack_public_path__ + "static/print-right-5db8a9d3121e5392cc2e77a259c3f3ba.jpg";